import type { CollectionItem } from '@elfsight/configurator-contracts';
import type { GoogleAnalyticsEventValue } from '@elfsight/lib-google-analytics';
import type {
  BadgeBlockProps,
  ButtonBlockProps,
  CouponBlockProps,
  FormBlockProps,
  HeadingBlockProps,
  HtmlBlockProps,
  IframeBlockProps,
  ImageBlockProps,
  LinkBlockProps,
  SeparatorBlockProps,
  SpacingBlockProps,
  TextBlockProps,
  VideoBlockProps
} from './widget';

export enum Layout {
  EmbeddedMedia = 'embeddedMedia',
  LeftMedia = 'leftMedia',
  RightMedia = 'rightMedia',
  EmbeddedBanner = 'embeddedBanner',
  LeftBanner = 'leftBanner',
  RightBanner = 'rightBanner'
}

export enum DevicesVisible {
  AllDevices = 'allDevices',
  DesktopOnly = 'desktopOnly',
  MobileOnly = 'mobileOnly'
}

export type BlockType =
  | 'badge'
  | 'button'
  | 'coupon'
  | 'form'
  | 'html'
  | 'iframe'
  | 'image'
  | 'link'
  | 'separator'
  | 'spacing'
  | 'text'
  | 'heading'
  | 'video'
  | 'timer';

export type BlockProps = CollectionItem<{
  type: BlockType;
  editMode?: boolean;
  widgetId?: string;
  visible: boolean;
  devicesVisible: DevicesVisible;
}> &
  (
    | BadgeBlockProps
    | ButtonBlockProps
    | CouponBlockProps
    | FormBlockProps
    | HtmlBlockProps
    | IframeBlockProps
    | ImageBlockProps
    | LinkBlockProps
    | SeparatorBlockProps
    | SpacingBlockProps
    | TextBlockProps
    | HeadingBlockProps
    | VideoBlockProps
  );

export type GoogleAnalyticsEventValueType =
  | 'buttonClicked'
  | 'linkClicked'
  | 'couponCopied'
  | 'formStarted'
  | 'formSubmitted';
export type GoogleAnalyticsEventParameterType =
  | 'buttonText'
  | 'buttonUrl'
  | 'linkText'
  | 'linkUrl'
  | 'coupon';
export type GoogleAnalytics = GoogleAnalyticsEventValue<
  GoogleAnalyticsEventValueType,
  GoogleAnalyticsEventParameterType
>[];
